import React from 'react';
import { Row, Col } from 'react-bootstrap';
import ResourceDetails from '../../../components/ResourceDetails';
import { SUB_TYPES, PRESET_SUB_TYPES } from '../../../helpers/utility-types';

export default function AccountDetails(props) {
  const { account } = props;

  return (
    <>
      <Row>
        {Object.keys(SUB_TYPES).includes(account.account_type) &&
          PRESET_SUB_TYPES.includes(account.account_type) &&
          <Col md={2}>
            <ResourceDetails
              header={'Account Sub-Type'}
              value={Object.keys(SUB_TYPES[account.account_type]).includes(account.sub_type) ? SUB_TYPES[account.account_type][account.sub_type] : SUB_TYPES[account.account_type][0]}
            />
          </Col>}
        {Object.keys(SUB_TYPES).includes(account.account_type) &&
          !PRESET_SUB_TYPES.includes(account.account_type) &&
          <Col md={2}>
            <ResourceDetails
              header={'Account Sub-Type'}
              value={Object.keys(SUB_TYPES[account.account_type]).includes(account.sub_type) ? SUB_TYPES[account.account_type][account.sub_type] : account.sub_type}
            />
          </Col>}
        <Col md={2}>
          <ResourceDetails
            header={'Utility Provider'}
            value={account.utility_provider}
          />
        </Col>
        <Col md={2}>
          <ResourceDetails
            header={'Unit of Measure'}
            value={account.default_consumption_unit}
          />
        </Col>
        <Col md={2}>
          <ResourceDetails
            header={'Building(s)'}
            value={account.buildings.length}
          />
        </Col>
        <Col md={2}>
          <ResourceDetails
            header={'In Reports'}
            value={!account.exclude_from_reports ? 'True' : 'False'}
          />
        </Col>
      </Row>
    </>
  );
}
